import React from "react";
// MUI
import { Grid2 } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
// Styling
import styles from "./BlueprintSite.module.scss";
import { ReactComponent as Blueprint } from "../../../../../../GlobalAssets/svg/Blueprint12.svg";

export default function BlueprintSite(props) {
  const { blueprint, setBlueprint, blueprintData, onBlueprintSelect } = props;

  const handleSelectType = (index, blueprintId, title, siteType) => {
    if (blueprint?.index === index) {
      setBlueprint(null);
      onBlueprintSelect(null);
    } else {
      setBlueprint({ index, blueprintId, title, siteType });
      onBlueprintSelect(blueprintId, title, siteType);
    }
  };

  const BlueprintImage = ({ icon }) => {
    return icon ? (
      <img src={icon} alt="Blueprint" className={styles.Image} />
    ) : (
      <Blueprint className={styles.NoImage} />
    );
  };

  return (
    <>
      <Grid2 className={styles.BluePrint}>
        <Grid2 className={styles.header}>Blueprints</Grid2>
        <Grid2 className={styles.BluePrintFlexBox}>
          {blueprintData.map(
            ({ title, icon, blueprintId, siteType }, index) => (
              <Grid2
                key={index}
                className={`${styles.Container} ${
                  blueprint?.index === index ? styles.active : ""
                }`}
                onClick={() =>
                  handleSelectType(index, blueprintId, title, siteType)
                }
              >
                <BlueprintImage icon={icon} />
                <Grid2 className={styles.titleBackground}>
                  <Grid2 className={styles.title}>{title}</Grid2>
                </Grid2>
                {blueprint?.index === index && (
                  <Grid2 className={styles.tickBox}>
                    <CheckOutlinedIcon className={styles.Check} />
                  </Grid2>
                )}
              </Grid2>
            ),
          )}
        </Grid2>
      </Grid2>
    </>
  );
}
